import * as React from "react";
import * as _ from "lodash";
import { DietPrescriptionItemRequest } from "@curefit/gmf-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import ModelFactory from "../../../models/ModelFactory";
import {TabConfig} from "../../../utils/TabManager";
import {MealSlots} from "../../../utils/AppConstants";
import TabsHeader from "../../common/TabsHeader";
import AppUtils from "../../../utils/AppUtils";
import LocalStorageUtils from "../../../utils/LocalStorageUtils";
import {EventNames} from "../../../utils/EventTrackerConstants";

export interface PatientDietPlanViewProps {
    patientDietPlan: DietPrescriptionItemRequest
}

export interface PatientDietPlanViewState {
    allTabs: TabConfig[],
    activeTab: TabConfig,
    activeTabIdx: number
}

let DietPlanEditorThemeHeaderInfos: ICustomHeaderInfo[] = [
    {label: "themes", display: "THEMES"}
];

let DietPlanEditorGuidelineHeaderInfos: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES (DO's)"}
];

let DietPlanEditorGuidelineHeaderInfosDonts: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES (DONT's)"}
];

let DietPlanEditorCaloriesHeaderInfos: ICustomHeaderInfo[] = [
    {label: "calories", display: "TOTAL CALORIES / DAY"}
];

export default class PatientDietPlanView extends React.Component<PatientDietPlanViewProps, PatientDietPlanViewState> {

    constructor(props: PatientDietPlanViewProps) {
        super(props);
        let allTabs = !_.isEmpty(props.patientDietPlan.meals) ? this.generateTabList() : null;
        let activeTab = !_.isEmpty(allTabs) ? allTabs[0] : null;
        this.state = {
            allTabs,
            activeTab,
            activeTabIdx: 0
        }
    }

    generateTabList = () => {
        let headers: TabConfig[] = [];
        let currentMealSlots = this.props.patientDietPlan.meals;
        _.map(MealSlots, (name, key) => {
            let meal = currentMealSlots.filter(item => item.mealSlot === key);
            if (meal.length) {
                let tabConfig: TabConfig = ModelFactory.createNewTabConfig();
                const calories = meal[0].details.calories
                let formattedHeader = `${name.toUpperCase()}${calories && calories > 0 ? " - " + calories + "KCAL" : ""}`;
                tabConfig.id = key;
                tabConfig.tabName = key;
                tabConfig.display = formattedHeader;
                headers.push(tabConfig);
            }
        });
        return headers;
    };

    updateActiveTab= (activeTab: TabConfig, activeTabIdx: number) => {
        this.setState({activeTab: activeTab, activeTabIdx: activeTabIdx})
    }

    render () {
        let { patientDietPlan } = this.props;
        let { activeTabIdx, activeTab } = this.state;
        let toDoGuidelines = !_.isEmpty(patientDietPlan) && !_.isEmpty(patientDietPlan.guidelines) ? patientDietPlan.guidelines.filter(guideline => guideline && guideline.type === "DO") : [];
        let notToDoGuidelines = !_.isEmpty(patientDietPlan) && !_.isEmpty(patientDietPlan.guidelines) ? patientDietPlan.guidelines.filter(guideline => guideline && guideline.type === "DONT") : [];
        let meal = !_.isEmpty(patientDietPlan) && !_.isEmpty(patientDietPlan.meals) && AppUtils.isDefined(activeTab) ? patientDietPlan.meals.find(meal => meal.mealSlot === activeTab.tabName) : null;
        return (
            <div className={"patient-diet-plan-view-container"}>
                {
                    _.isEmpty(patientDietPlan.themes) && _.isEmpty(toDoGuidelines) && _.isEmpty(notToDoGuidelines) &&
                    <div>No Diet Plan to show</div>
                }
                {
                    !_.isEmpty(patientDietPlan) && !_.isEmpty(patientDietPlan.overallDietThemes) &&
                    <div>
                        <CustomHeader headerInfos={DietPlanEditorThemeHeaderInfos} rootCls={"patient-diet-plan-themes"}/>
                        <div className={"diet-plan-themes-container"}>
                            {
                                !_.isEmpty(patientDietPlan) && !_.isEmpty(patientDietPlan.themes) && patientDietPlan.themes.map((theme: string, index: number) => {
                                    return (
                                        <p className={"diet-plan-theme"} key={`diet-plan-theme-${index}`}>{theme}</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                }

                <div className={"guidelines-container"}>
                    {
                        !_.isEmpty(toDoGuidelines) &&
                        <div className={"guidelines-column-container"}>
                            <CustomHeader headerInfos={DietPlanEditorGuidelineHeaderInfos} rootCls={"patient-diet-plan-guidelines"}/>
                            {
                                _.map(toDoGuidelines, (guideline: any, index: number) => {
                                    return <p key={`guideline-${index}`}>{guideline.guideline}</p>
                                })
                            }
                        </div>
                    }
                    {
                        !_.isEmpty(notToDoGuidelines) &&
                        <div className={"guidelines-column-container"}>
                            <CustomHeader headerInfos={DietPlanEditorGuidelineHeaderInfosDonts} rootCls={"patient-diet-plan-guidelines"}/>
                            {
                                _.map(notToDoGuidelines, (guideline: any, index: number) => {
                                    return <p key={`guideline-${index}`}>{guideline.guideline}</p>
                                })
                            }
                        </div>
                    }
                </div>
                {
                    !_.isEmpty(this.state.allTabs) && !_.isEmpty(this.state.allTabs) &&
                    <div className={"meal-builder-container"}>
                        <TabsHeader tabs={this.state.allTabs} activeTab={this.state.activeTab} updateActiveTab={this.updateActiveTab}  trackerEvents={{ flow: EventNames.Consultation }} />
                        {
                            AppUtils.isDefined(meal) &&
                            <div className={"diet-plan-meal-container"}>
                                <div className={"meal-container"}>
                                    <div className={"meal-time"}>
                                        <span className="meal-time-label">Meal Time:</span>
                                        {meal.recommendedTimeOfDay}
                                    </div>
                                    {
                                        (meal.details.calorieBreakup || []).map((mealBreakup: any) => {
                                            return(
                                                <div className={"meal-break-up"}>
                                                    <span className={"theme-label brandon-bold"}>Theme</span>
                                                    {mealBreakup.map((item: any) => {
                                                        return(
                                                            <span className={"food-group-item-container"}>
                                                                <span className={"food-group-label"}>{`${item.foodgroups[0]}`}</span>
                                                                <span className={"food-group-percentage"}>{`${item.contribution}%`}</span>
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {
                                    (meal.details.mealIds || []).map((mealId: string) => {
                                        const currentMeal = LocalStorageUtils.getMealFromMealId(mealId);
                                        const totalCalories = !_.isEmpty(currentMeal) && !_.isEmpty(currentMeal.nutritionInfo) && currentMeal.nutritionInfo.calories !== undefined ? parseInt(currentMeal.nutritionInfo.calories.toString()) + " kcal" : null;
                                        if (!AppUtils.isDefined(currentMeal)) return null;
                                        return(
                                            <div className={"current-meal-container meal-item-editor"} key={mealId}>
                                                <p className={"current-meal-header brandon-bold"}>{`${currentMeal.name} ${AppUtils.isDefined(totalCalories) ? " - " + totalCalories : ""}`}</p>
                                                <div className={"dishes-header brandon-bold"}>DISHES</div>
                                                {
                                                    !_.isEmpty(currentMeal.components) &&
                                                    <div className={"meal-item-components"}>
                                                        {
                                                            _.map(currentMeal.components, (component, index) => {
                                                                return (
                                                                    <div className={"dish-component"} key={`meal-item-${index}`}>
                                                                        <div className={"name-label brandon-bold"}>{component.displayName}</div>
                                                                        <div>
                                                                            <span className={"dish-unit"}>{`${component.quantity} ${component.unit}`}</span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}